import LZString from 'lz-string';
export default class Utils {
  /**
   * @returns {string}
   */
  static generateUUID() {
    let d = new Date().getTime(); //Timestamp
    let d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        let r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  /**
   * @param {string} url
   * @param {number} take
   * @param {number} skip
   * @returns {string}
   */
  static getFilterParams(url, take = 0, skip = 0) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}filter=[{"skip":${skip},"take":${take}}]`;
}

  static goBack(appId, detail = {}) {
    document.getElementById(`navigation_${appId}`)?.dispatchEvent(
      new CustomEvent("stepDownPage", {
        detail,
        bubbles: true,
      })
    );
  }

  static safeParseJSON(value) {
    try {
      if(/^\d+$/.test(value)) return value; // Keep original value if it's a number
      else return JSON.parse(value);
    } catch {
      return value; // Keep original value if parsing fails
    }
  }

  static loadGoogleTranslate = (languageCode, containerElement) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.head.appendChild(script);
  
    window.googleTranslateElementInit = function () {
      new google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: languageCode
      }, containerElement);
    };
  };

  static openShareLink({ action, document, fileId, getMessage, appId }) {
    const alertAdapter = OSjs?.make("oxzion/alert");
    const helper = OSjs?.make("oxzion/restClient");

    alertAdapter?.show({
      title: `Creating ${action} link...`,
      icon: "info",
      allowOutsideClick: false,
    });

    helper.request(
      "v1",
      `app/${appId}/file/${fileId}/attachment/${document.uuid}/${action}`,
      {
        callbacks: {
          onOpen: () =>
            alertAdapter?.update({
              title: `Establishing connection... Processing ${action} link. Please wait.`,
              icon: "info",
              allowOutsideClick: false,
            }),
          onSuccess: (data) => {
            window.open(data.sharableLink, "_blank");
            alertAdapter?.update({
              title: getMessage(data) || "Successfully created the sharing link",
              icon: "success",
              confirmButtonText: "Got it",
              allowOutsideClick: false,
            });
          },
          onError: (data) => {
            alertAdapter?.update({
              title: getMessage(data) || `Failed to create ${action} link. Please try again.`,
              icon: "error",
              confirmButtonText: "Got it",
              allowOutsideClick: false,
            });
          },
          onUpdateStatus: (data) => {
            alertAdapter?.update({
              title: getMessage(data) || "Processing...",
              icon: "info",
              allowOutsideClick: false,
            });
          },
        },
        method:'GET'
      },
      "SSE",
    );
  };

  static encodeToBase64 = (value) => {
    return LZString.compressToBase64(value);
  };

  static decodeFromBase64 = (value) => {
    return LZString.decompressFromBase64(value);
  };

  static isValidDateFormat = (value) => {
    // Regex patterns for different formats
    const mmddyyyy = /^(0?[1-9]|1[0-2])[-\/](0?[1-9]|[12][0-9]|3[01])[-\/]\d{4}$/;
    const ddmmyyyy = /^(0?[1-9]|[12][0-9]|3[01])[-\/](0?[1-9]|1[0-2])[-\/]\d{4}$/;
    const yyyyddmm = /^\d{4}[-\/](0?[1-9]|[12][0-9]|3[01])[-\/](0?[1-9]|1[0-2])$/;
    const yyyymmdd = /^\d{4}[-\/](0?[1-9]|1[0-2])[-\/](0?[1-9]|[12][0-9]|3[01])$/;

    return (
      mmddyyyy.test(value) ||
      ddmmyyyy.test(value) ||
      yyyyddmm.test(value) ||
      yyyymmdd.test(value)
    );
  };
}
